<template>
  <div id="container" data-type="vhome">
    <div class="page page-home" v-ga:request="{ pageType: 'vhome', state: home }"
      v-ga:page="{ pageType: 'vhome', glb: glb }">
      <div class="fixed fixed-lg">
        <mvtHeader :disableSearch="true"></mvtHeader>
      </div>
      <main>
        <homeWelcome></homeWelcome>
        <homeTopActions></homeTopActions>
        <homeNearbyViewed class="inline p-y-4 p-x-0" v-if="showRecentlyViewed && getShowList('viewed')"></homeNearbyViewed>
        <homePopularCities></homePopularCities>
        <homePhotos></homePhotos>
        <homeLinks></homeLinks>
        <homeNavigation></homeNavigation>
        <homeHotlead></homeHotlead>
      </main>
      <mvtFooter />
    </div>
    <mvtPopSignin />
    <mvtDialogCenter></mvtDialogCenter>
  </div>
</template>

<script src="./page-home.js"></script>

<style lang="scss">
@use "./page-home.scss" as *;
</style>